<template>
  <span>Augnablik...</span>
</template>

<script>
export default {
  name: 'Loading',
};
</script>
